import React from "react";
import Header from "components/header";

import SideBar from "components/sidebar/sideBar";
import SubSideBar from "components/subSideBar/subSideBar";

const MainLayout = ({
  children,
  activeComponent,
  match,
  isUserProfile,
  isBack,
  getBackPath,
  pageName,
  subSideBar=false,
  setSelectedTab,
  showSide=false,
}) => {
  return (
    
      <>
        <Header
          isUserProfile={isUserProfile}
          isBack={isBack}
          getBackPath={getBackPath}
          pageName={pageName}
          showSide={showSide}
        />
      
      
        <div className="body-container">
          <SideBar activeComponent={activeComponent} match={match} />
          {subSideBar ? <SubSideBar setSelectedTab={setSelectedTab} />:null}
          {children}
        </div>
      </>
    
  );
};

export default MainLayout;
